import {
	SettingUnitMasterInfoFieldTypeEnum,
	SettingUnitMasterInfoFieldTypeLabelEnum,
} from '@/constant';
import {
	TGetSettingMasterInfoResponse,
	TSettingApplicantStatus,
	TSettingOptionalField,
	TSettingUnitDistrict,
} from '@/services';

import { map } from 'utils';

export const formatDistrictDetail = (input: TSettingUnitDistrict) => {
	return {
		...input,
		label: input.name,
		value: input.id,
	};
};

export const formatDistrictList = (input: TSettingUnitDistrict[]) => {
	return map(input, formatDistrictDetail);
};

export const formatStatusDetail = (input: TSettingApplicantStatus) => {
	return {
		...input,
		label: input.name,
		value: input.id,
	};
};

export const formatStatusList = (input: TSettingApplicantStatus[]) => {
	return map(input, formatStatusDetail);
};

export const formatOptionalFieldDetail = (input: TSettingOptionalField) => {
	return {
		...input,
		label: input.name,
		value: input.id,
		type: input.dataType,
		typeName:
			input.dataType === SettingUnitMasterInfoFieldTypeEnum.DATE
				? SettingUnitMasterInfoFieldTypeLabelEnum.DATE
				: SettingUnitMasterInfoFieldTypeLabelEnum.TEXT,
	};
};

export const formatOptionalFieldList = (input: TSettingOptionalField[]) => {
	return map(input, formatOptionalFieldDetail);
};

export const formatOption = (
	input: TSettingApplicantStatus | TSettingUnitDistrict
) => {
	return {
		value: input.id,
		label: input.name,
		id: input.id,
	};
};

export const formatListOption = (
	input: TSettingApplicantStatus[] | TSettingUnitDistrict[]
) => {
	return map(input, formatOption);
};

export const formatSettingMasterInfo = (
	input: TGetSettingMasterInfoResponse
) => {
	return {
		districtList: formatDistrictList(input.districtList),
		districtListOption: formatListOption(input.districtList),
		statusList: formatStatusList(input.statusList),
		statusListOption: formatListOption(input.statusList),
		issuanceStatusList: formatStatusList(input.issuanceStatusList),
		issuanceStatusListOption: formatListOption(input.issuanceStatusList),
		optionalFieldApplicantList: formatOptionalFieldList(
			input.optionalFieldApplicantList
		),
		optionalFieldFranchiseList: formatOptionalFieldList(
			input.optionalFieldFranchiseList
		),
	};
};
